module.exports = __webpack_public_path__ + "img/logo_iol.f31cc27a.png";